// extracted by mini-css-extract-plugin
module.exports = {"albumVideoContainer":"common-Albums__albumVideoContainer--3FBa0"};